import { Component, OnInit } from '@angular/core';
import { AssetTypeService } from 'src/app/services/asset-type.service';

@Component({
  selector: 'app-view-asset-modal',
  templateUrl: './view-asset-modal.page.html',
  styleUrls: ['./view-asset-modal.page.scss'],
})
export class ViewAssetModalPage implements OnInit {

  public assetModalData: any = {};

  constructor(public assetTypeService: AssetTypeService) { }

  ngOnInit() {
  }

  getType(id){
    return this.assetTypeService.getType(id);
  }
}
